// modules/admin/ui.ts — <app-admin>
// Panel de administración. Solo se monta si el usuario tiene rol 'admin'.

import { getModule } from '../../core/registry';
import { formatDate } from '../../shared/utils/format';
import type { AdminUser } from './contracts';

export class AppAdmin extends HTMLElement {
  static define() { customElements.define('app-admin', AppAdmin); }

  async connectedCallback() {
    this.innerHTML = `
      <style>
        :host { display:block;padding:var(--space-4);max-width:var(--container-lg);margin:0 auto; }
        h1    { font-family:var(--font-display);font-size:var(--text-2xl);margin-bottom:var(--space-4); }
        table { width:100%;border-collapse:collapse;font-size:var(--text-sm); }
        th,td { padding:var(--space-3);text-align:left;border-bottom:1px solid var(--color-border); }
        th    { font-weight:var(--font-weight-semibold);color:var(--color-text-muted);background:var(--color-surface); }
        tr:hover td { background:var(--color-surface); }
        .badge { display:inline-block;padding:2px 8px;border-radius:var(--radius-full);font-size:0.7rem;font-weight:var(--font-weight-semibold); }
        .free  { background:var(--color-border);color:var(--color-text-muted); }
        .pro   { background:var(--color-primary);color:#fff; }
      </style>
      <h1>Panel de administración</h1>
      <div id="tableWrap">Cargando usuarios…</div>
    `;

    try {
      const users = await getModule<{ listUsers: (p?: number) => Promise<AdminUser[]> }>('admin')?.listUsers() ?? [];
      this.querySelector('#tableWrap')!.innerHTML = `
        <table>
          <thead>
            <tr>
              <th>Email</th><th>Nombre</th><th>Plan</th><th>Key</th><th>Registro</th><th>Último acceso</th>
            </tr>
          </thead>
          <tbody>
            ${users.map(u => `
              <tr>
                <td>${u.email}</td>
                <td>${u.nickname ?? '—'}</td>
                <td><span class="badge ${u.plan}">${u.plan}</span></td>
                <td>${u.hasGeminiKey ? '✓' : '—'}</td>
                <td>${formatDate(u.createdAt)}</td>
                <td>${formatDate(u.lastActiveAt)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
        <p style="font-size:var(--text-xs);color:var(--color-text-muted);margin-top:var(--space-3)">${users.length} usuarios</p>
      `;
    } catch (err) {
      this.querySelector('#tableWrap')!.innerHTML = `<p style="color:var(--color-error)">Error cargando usuarios: ${err instanceof Error ? err.message : 'desconocido'}</p>`;
    }
  }
}
